import { render, staticRenderFns } from "./FormValidation.vue?vue&type=template&id=90e248b8&scoped=true&"
import script from "./FormValidation.vue?vue&type=script&lang=ts&"
export * from "./FormValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e248b8",
  null
  
)

export default component.exports